import { createAction } from 'redux-actions'

import * as Actions from '@src/actions/Actions'
import { Crumb } from '@src/types/models'

export const addCrumb = createAction<Crumb>(Actions.CRUMB_ADD)
export const updateCrumb = createAction<Crumb>(Actions.CRUMB_UPDATE)
export const deleteCrumb = createAction<string>(Actions.CRUMB_DELETE)
